import { render, staticRenderFns } from "./Checkpoint.vue?vue&type=template&id=087f2984&scoped=true&"
import script from "./Checkpoint.vue?vue&type=script&lang=js&"
export * from "./Checkpoint.vue?vue&type=script&lang=js&"
import style0 from "./Checkpoint.vue?vue&type=style&index=0&id=087f2984&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "087f2984",
  null
  
)

export default component.exports